import Component from '../Component';

export default class CustomSelect extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.isOpen = false;
    this.selectedValue = this.attrs.value || '';
    this.selectedIndex = -1;
  }

  view() {
    const { options, tip } = this.attrs;
    const optionEntries = Object.entries(options);

    return m('div.CustomSelect', [
      // 输入框+下拉箭头
      m('div.CustomSelect-header', {
        onclick: () => this.toggleDropdown(),
        onkeydown: (e) => this.handleKeyPress(e),
        role: 'combobox',
        'aria-expanded': this.isOpen,
        'aria-haspopup': 'listbox',
        tabindex: 0,
      }, [
        m('span.CustomSelect-value', options[this.selectedValue] || tip),
      ]),
      
      // 下拉列表
      this.isOpen && m('div.CustomSelect-list', {
        role: 'listbox',
        'aria-label': 'Select options'
      }, optionEntries.map(([value, label], index) =>
        m('div.CustomSelect-item', {
          role: 'option',
          'aria-selected': value === this.selectedValue,
          class: index === this.selectedIndex ? 'is-active' : '',
          onclick: () => this.selectValue(value),
          onmouseenter: () => this.hoverOption(index),
          onkeydown: (e) => this.handleItemKey(e, value)
        }, label)
      ))
    ]);
  }

  // 交互方法
  toggleDropdown() {
    this.isOpen = !this.isOpen;
    this.selectedIndex = this.isOpen ? 0 : -1;
    m.redraw();
  }

  selectValue(value) {
    this.selectedValue = value;
    this.isOpen = false;
    this.attrs.onchange?.(value);
  }

  hoverOption(index) {
    this.selectedIndex = index;
    m.redraw();
  }

  // 键盘交互
  handleKeyPress(e) {
    const { key } = e;
    const optionsCount = Object.keys(this.attrs.options).length;
    
    if (key === 'ArrowDown') this.navigate(1, optionsCount);
    if (key === 'ArrowUp') this.navigate(-1, optionsCount);
    if (key === 'Enter' && this.selectedIndex >= 0) this.confirmSelection();
    if (key === 'Escape') this.isOpen = false;
  }

  handleItemKey(e, value) {
    if (e.key === 'Enter') this.selectValue(value);
  }

  navigate(step, max) {
    this.selectedIndex = (this.selectedIndex + step + max) % max;
    this.scrollToSelection();
  }

  scrollToSelection() {
    const activeItem = this.element?.querySelector('.is-active');
    activeItem?.scrollIntoView({ block: 'nearest' });
  }
}